// extracted by mini-css-extract-plugin
module.exports = {"DetailPageView":"DetailPageView_DetailPageView__17Hc9","container":"DetailPageView_container__1mKms","sidebar":"DetailPageView_sidebar__3HlU5","main":"DetailPageView_main__1gbcQ"};